import { render, staticRenderFns } from "./LoyaltiyRewardSettings.vue?vue&type=template&id=51d306cb&scoped=true"
import script from "./LoyaltiyRewardSettings.vue?vue&type=script&lang=js"
export * from "./LoyaltiyRewardSettings.vue?vue&type=script&lang=js"
import style0 from "./LoyaltiyRewardSettings.vue?vue&type=style&index=0&id=51d306cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d306cb",
  null
  
)

export default component.exports